import React from 'react';
import PropTypes from 'prop-types';

import '../style/score.css';

const Score = ({ count, scoretype }) => (
  <div className={`score__${scoretype}`}>
    {count}
  </div>
);

Score.propTypes = {
  count: PropTypes.number.isRequired,
  scoretype: PropTypes.string.isRequired,
};

export default Score;



// WEBPACK FOOTER //
// ./src/components/Score.js